module.exports = __webpack_public_path__ + "img/mini-p-teacher.a53d702e.png";